import { render, staticRenderFns } from "./PushNotice.vue?vue&type=template&id=5c9077d4&scoped=true"
import script from "./PushNotice.vue?vue&type=script&lang=js"
export * from "./PushNotice.vue?vue&type=script&lang=js"
import style0 from "./PushNotice.vue?vue&type=style&index=0&id=5c9077d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9077d4",
  null
  
)

export default component.exports